import { useCallback } from "react";

import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

/**
 * Returns a function that captures the selected organization's id for a
 * submission, or shows the "No organization selected" error toast and returns
 * `undefined` when there is none.
 */
export function useRequireSelectedOrgId(): () => string | undefined {
  const { selectedOrganization } = useAuth();
  const { toast } = useToast();
  const orgId = selectedOrganization?.id;

  return useCallback(() => {
    if (!orgId) {
      toast({
        title: "Error",
        description: "No organization selected",
        variant: "destructive",
      });
      return undefined;
    }
    return orgId;
  }, [orgId, toast]);
}
